import type {
  QueueDataPointStatus,
  QueueDataStatus,
  QueueQualityReason,
} from "@situate/contracts/runtime";

const LOW_FLOW_REASONS: ReadonlySet<QueueQualityReason> = new Set([
  "LOW_OCCUPANCY",
  "NO_EXIT_FLOW",
  "LOW_EXIT_FLOW",
]);

interface QueueWaitState {
  value: number | null;
  dataStatus: QueueDataStatus | QueueDataPointStatus;
  qualityReasons?: readonly QueueQualityReason[];
}

export function isNearEmptyQueueWait(state: QueueWaitState): boolean {
  if (state.dataStatus !== "current" && state.dataStatus !== "partial") return false;
  if (state.value !== null && state.value !== 0) return false;
  const reasons = state.qualityReasons ?? [];
  return reasons.length > 0 && reasons.every((reason) => LOW_FLOW_REASONS.has(reason));
}

export function formatQueueWait(value: number | null, nearEmpty = false): string {
  if (value == null) return "Wait unavailable";
  if (nearEmpty) return "<1 minute";
  return `${value} ${value === 1 ? "minute" : "minutes"}`;
}

export function formatQueueWaitShort(value: number | null, nearEmpty = false): string {
  if (value == null) return "– wait";
  if (nearEmpty) return "<1m wait";
  return `${Math.round(value)}m wait`;
}

export function formatQueueWaitCard(value: number | null, nearEmpty = false): string {
  if (value == null) return "Wait unavailable";
  if (nearEmpty) return "<1 minute";
  return `~${Math.round(value)} min wait`;
}

/** Keeps a near-empty historical point visible at the one-minute chart floor. */
export function toChartQueueWaitMinutes(value: number | null, nearEmpty: boolean): number | null {
  return nearEmpty ? 0.999 : value;
}
